import { render } from "./GeographicSustainTableCt.vue?vue&type=template&id=522b5e88"
import script from "./GeographicSustainTableCt.vue?vue&type=script&lang=js"
export * from "./GeographicSustainTableCt.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__